import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { variantToProps } from '@invitae/iconograph-react-core';
import { style } from '../common.esm.js';
import IconHeart$2 from './icon-heart-md.esm.js';
import IconHeart$1 from './icon-heart-sm.esm.js';

var IconHeart = function (_a) {
    var size = _a.size, circle = _a.circle, color = _a.color, _b = _a.currentColor, currentColor = _b === void 0 ? false : _b, className = _a.className, rest = __rest(_a, ["size", "circle", "color", "currentColor", "className"]);
    var ChildComponent = size === 'small' ? IconHeart$1 : IconHeart$2;
    var childProps = variantToProps({ size: size, circle: circle, color: color, currentColor: currentColor });
    var childStyle = __assign(__assign({}, style), rest.style);
    var childClass = "".concat(className ? "".concat(className, " ") : '', "nv-icon");
    return (React__default.createElement(ChildComponent, __assign({ className: childClass, role: "img" }, childProps, rest, { style: childStyle })));
};

export { IconHeart as default };
//# sourceMappingURL=index.esm.js.map
